import axios from "axios";
import { getHeaderToken } from "../utils/serviceHelper";
import { PositiveItem } from "../types/positiveItem";
import { errorToast, successToast } from "@idwal/idwal-react-components";

export const getPositiveItems = async (inspectionId: string) => {
    const url = process.env.REACT_APP_IDWAL_API_ENDPOINT + `/PositiveItems/inspection/${inspectionId}`;

    const headers = await getHeaderToken();

    try {
        const response = await axios.get(url, { headers });

        if (response.data?.items) {
            return response.data.items;
        }
    } catch (error) {
        errorToast(`Failed to get defects for inspection: ${inspectionId}`);
    }
}

export const addPositiveItem = async (positiveItem: PositiveItem) => {
    const url = process.env.REACT_APP_IDWAL_API_ENDPOINT + `/PositiveItems/inspection/${positiveItem.inspectionId}`;

    const headers = await getHeaderToken();

    const data = JSON.stringify(positiveItem);

    try {
        const response = await axios.post(url, data, { headers });

        if (response.data.item) {
            successToast("Successfully added positive item");

            return response.data.item;
        }
    } catch (error) {
        errorToast("Failed to add positive item");
    }
}

export const updatePositiveItem = async (positiveItem: PositiveItem) => {  
    const url = process.env.REACT_APP_IDWAL_API_ENDPOINT + `/PositiveItems/${positiveItem.id}`;

    const headers = await getHeaderToken();

    const data = JSON.stringify(positiveItem);

    try {
        const response = await axios.put(url, data, { headers });

        if (response.status === 200) {
            successToast("Successfully updated positive item");

            return true;
        }
    } catch (error) {
        errorToast("Failed to update positive item");
    }
}

export const deletePositiveItem = async (positiveItems: PositiveItem[]) => {   
    const url = process.env.REACT_APP_IDWAL_API_ENDPOINT + `/PositiveItems/inspection/${positiveItems[0].inspectionId}`;

    const token = await getHeaderToken();
    const headers = { Authorization: token.Authorization };

    const ids = positiveItems.map(positiveItem => positiveItem.id).join(',');
    const data = encodeURI(`itemIds=[${ids}]`);

    try {
        const response = await axios.delete(url, { headers, data });

        if (response.status === 200) {
            successToast("Successfully deleted positive item(s)");

            return true;
        }
    } catch {
        errorToast("Failed to delete positive item");
    }
}